import React from "react";
import { clsx } from "~/sdk/clx"
import type { JSX } from "react"

export default function () {
    return {
        Collapsable: ({
            children,
            open,
            id,
            ...props
        }: React.JSX.IntrinsicElements['div'] & {
            id: string
            open?: boolean
        }) => (
            <div {...props}>
                <input type='checkbox' id={id} className='hidden peer' checked={open} />
                {children}
            </div>
        ),

        Trigger: ({ className, ...props }: React.JSX.IntrinsicElements['label'] & { htmlFor: string }) => (
            <label {...props} className={clsx('cursor-pointer select-none', className)} />
        ),

        ContentWrapper: ({
            customTransition,
            className,
            ...props
        }: React.JSX.IntrinsicElements['div'] & {
            customTransition?: boolean
        }) => (
            <div
                {...props}
                className={clsx(
                    'group grid transition-all',
                    !customTransition && 'grid-rows-[0fr] peer-checked:grid-rows-[1fr]',
                    className,
                )}
            />
        ),

        Content: ({ noOverflow, className, ...props }: React.JSX.IntrinsicElements['div'] & { noOverflow?: boolean }) => (
            <div
                {...props}
                className={clsx(
                    '[grid-row:1_/_span_2]',
                    !noOverflow && 'overflow-hidden',
                    className,
                )}
            />
        ),
    }
}
